export interface Warehouse {
  id: number;
  name: string;
  acronym: string;
  isRevivn: boolean;
}

export const warehouses: Warehouse[] = [
  { id: 1, name: "New York", acronym: "NY", isRevivn: true },
  { id: 2, name: "San Francisco", acronym: "SF", isRevivn: true },
  { id: 3, name: "Fresno", acronym: "FR", isRevivn: true },
  { id: 4, name: "KOcycle", acronym: "KO", isRevivn: false },
  { id: 5, name: "3PL", acronym: "3PL", isRevivn: false },
];
